module.exports = __webpack_public_path__ + "media/icons/slider-point@3x-c51fe75a.svg";